import { severityClass } from '../utils/severity.js';

const STATUS_SEVERITY = {
  APPROVED: 'OK',
  'CORRECTIONS REQUIRED': 'WARNING',
  REJECTED: 'CRITICAL',
};

/**
 * Wide banner below the score row. Renders the engine's `verdict.narrative`
 * verbatim — no paraphrasing, no UI-invented copy (Data Integrity Rule).
 * Border + tint follow the verdict severity.
 *
 * G2.3.5: `verdict.narrative` is the canonical single string emitted by the
 * engine (verdict.js). PDF cover and this dashboard banner render the same
 * bytes (Permanent Rule 12).
 *
 * SURFACE-COHERE (item C+E): when `onExplain` is supplied, a "How is the verdict
 * decided?" link is appended that opens the "How to read this report" panel
 * (which carries the engine's verdictRule). The engine verdict.js is untouched.
 */
export function VerdictBox({ verdict, onExplain }) {
  if (!verdict) return null;
  const severity = STATUS_SEVERITY[verdict.status] || 'WARNING';
  const cls = severityClass(severity);
  return (
    <div className={`verdict-box verdict-box-${cls}`} role="status">
      <strong className="verdict-status">{verdict.status}</strong>
      <span className="verdict-separator"> — </span>
      <span className="verdict-statement">{verdict.narrative}</span>
      {onExplain && (
        <button type="button" className="verdict-explain-link" onClick={onExplain}>
          How is the verdict decided?
        </button>
      )}
    </div>
  );
}
